import { IManualInvoiceLineItemTax } from '@nkr/models/index';
import { Button } from 'react-bootstrap';

interface IProps {
    data: IManualInvoiceLineItemTax,
    onDelete: (id: number) => void
}

const TaxRow = (props: IProps) => {
    return (
        <tr>
            <td>{props.data.lineItemTypeDesc}</td>
            <td style={{ textAlign: 'center' }}>{props.data.taxPercent}%</td>
            <td><Button bsStyle='danger' bsSize='sm' block onClick={() => props.onDelete(props.data.id)}>Delete</Button></td>
        </tr>
    );
}

export default TaxRow;